import {
    BLOCKUNBLOCKUSER_SUCCESS,
    BLOCKUNBLOCKUSER_FAILED,
    RESET_BLOCKUNBLOCKUSER,
    LOADING_BLOCKUNBLOCKUSER,
    NETWORK_ERROR_BLOCKUNBLOCKUSER
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetBlockUnblockUser = () => {
    return { type: RESET_BLOCKUNBLOCKUSER };
};

const blockUnblockUser = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_BLOCKUNBLOCKUSER });
    await partnerServices
        .post("BlockUnBlock", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(blockUnblockUsersuccess(res.data));
                    break;
                default:
                    dispatch(blockUnblockUserFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_BLOCKUNBLOCKUSER,
                payload: err
            });
        });
};
function blockUnblockUsersuccess(data) {
    return {
        type: BLOCKUNBLOCKUSER_SUCCESS,
        payload: data
    };
}
function blockUnblockUserFailed(data) {
    return {
        type: BLOCKUNBLOCKUSER_FAILED,
        payload: data
    };
}

export { resetBlockUnblockUser, blockUnblockUser };
